export default __webpack_public_path__ + "static/Bez-nazwy-2-5d3c5fdcddc3def36de7e7bd21d6fda1.jpg";